/* eslint-disable */
// Action type constants for admin user role module
export const ADMIN_USER_ROLE_GET_STATUS_COUNT = 'ADMIN_USER_ROLE_GET_STATUS_COUNT';
export const ADMIN_USER_ROLE_GET_STATUS_COUNT_SUCCESS = 'ADMIN_USER_ROLE_GET_STATUS_COUNT_SUCCESS';
export const ADMIN_USER_ROLE_GET_STATUS_COUNT_FAILURE = 'ADMIN_USER_ROLE_GET_STATUS_COUNT_FAILURE';

export const ADMIN_USER_ROLE_ADD_USER = 'ADMIN_USER_ROLE_ADD_USER';
export const ADMIN_USER_ROLE_ADD_USER_SUCCESS = 'ADMIN_USER_ROLE_ADD_USER_SUCCESS';
export const ADMIN_USER_ROLE_ADD_USER_FAILURE = 'ADMIN_USER_ROLE_ADD_USER_FAILURE';

export const ADMIN_USER_ROLE_UPDATE_FILTER = 'ADMIN_USER_ROLE_UPDATE_FILTER';
export const ADMIN_USER_ROLE_SET_ACTIVE_STATUS = 'ADMIN_USER_ROLE_SET_ACTIVE_STATUS';

export const ADMIN_USER_ROLE_TOGGLE_ADD_USER_DRAWER = 'ADMIN_USER_ROLE_TOGGLE_ADD_USER_DRAWER';
export const ADMIN_USER_ROLE_CLEAR_USER_FORM = 'ADMIN_USER_ROLE_CLEAR_USER_FORM';

export const ADMIN_USER_ROLE_GET_ROLES = 'ADMIN_USER_ROLE_GET_ROLES';
export const ADMIN_USER_ROLE_GET_ROLES_SUCCESS = 'ADMIN_USER_ROLE_GET_ROLES_SUCCESS';
export const ADMIN_USER_ROLE_GET_ROLES_FAILURE = 'ADMIN_USER_ROLE_GET_ROLES_FAILURE';

export const ADMIN_USER_ROLE_GET_ROLES_LIST = 'ADMIN_USER_ROLE_GET_ROLES_LIST';
export const ADMIN_USER_ROLE_GET_ROLES_LIST_SUCCESS = 'ADMIN_USER_ROLE_GET_ROLES_LIST_SUCCESS';
export const ADMIN_USER_ROLE_GET_ROLES_LIST_FAILURE = 'ADMIN_USER_ROLE_GET_ROLES_LIST_FAILURE';

export const ADMIN_USER_ROLE_INCREMENT_CLEAR_SELECTION = 'ADMIN_USER_ROLE_INCREMENT_CLEAR_SELECTION';

// Client selection actions
export const ADMIN_USER_ROLE_SET_SELECTED_CLIENT = 'ADMIN_USER_ROLE_SET_SELECTED_CLIENT';
export const ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT = 'ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT';
export const ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT_SUCCESS = 'ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT_SUCCESS';
export const ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT_FAILURE = 'ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT_FAILURE';
